import React from "react";
import Reveal from "./Reveal";
import { CircleCheck } from "lucide-react";
import { FLEET, TRANSFER_POINTS } from "../mock";

const Transfers = () => {
  return (
    <section
      id="transfers"
      data-testid="transfers-section"
      className="bg-white py-24 lg:py-32 relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal className="max-w-2xl">
          <p className="uppercase tracking-[0.3em] text-xs font-normal text-[#B88A3B]">
            Transfer Services
          </p>
          <h2 className="font-serif-lux font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight mt-6">
            Luxury &amp; Professional{" "}
            <span className="gold-text italic">Transfer Services</span>
          </h2>
        </Reveal>
        <div className="grid md:grid-cols-3 gap-6 mt-16">
          {FLEET.map((f, i) => (
            <Reveal key={f.title} delay={i * 0.08} className="group">
              <div className="border border-[#B88A3B]/20 h-full">
                <div className="overflow-hidden aspect-[3/2]">
                  <img
                    alt={f.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    src={f.image}
                  />
                </div>
                <div className="p-6 flex items-baseline justify-between gap-4 border-t border-[#B88A3B]/20">
                  <h3 className="font-serif-lux text-2xl font-medium tracking-tight">
                    {f.title}
                  </h3>
                  <p className="uppercase tracking-[0.2em] text-xs text-[#B88A3B] whitespace-nowrap">
                    {f.seats}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal className="mt-14 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10" delay={0.1}>
          <ul className="space-y-3">
            {TRANSFER_POINTS.map((p) => (
              <li
                key={p}
                className="flex items-start gap-3 text-base text-[#18324F]/75 leading-relaxed"
              >
                <CircleCheck size={18} strokeWidth={1.4} className="text-[#B88A3B] mt-1 shrink-0" />
                {p}
              </li>
            ))}
          </ul>
          <a
            href="#contact"
            className="inline-block self-start bg-[#B88A3B] text-white px-8 py-4 uppercase tracking-[0.2em] text-sm font-medium hover:bg-[#C09245] hover:-translate-y-1 transition-[background-color,transform] duration-300"
          >
            Book a Transfer
          </a>
        </Reveal>
      </div>
    </section>
  );
};

export default Transfers;
